$_vikon(() => {
    $_vikon('.vikon-wrapper .vikon-tabs .vikon-nav-item .vikon-nav-link').click((event) => {
        event.preventDefault();
        const $target = $_vikon(event.target);
        const $allNavItems = $target.closest('.vikon-tabs').find('.vikon-nav-item');
        const $allNavLinks = $allNavItems.find('.vikon-nav-link');

        $allNavItems.removeClass('active');
        $target.closest('.vikon-nav-item').addClass('active');

        $allNavLinks.each((index, el) => {
            const tabPaneId = $_vikon(el).attr('href');
            $_vikon(`${tabPaneId}.vikon-tab-pane`).removeClass('active');
        });

        const activeTabId = $target.attr('href');
        $_vikon(`${activeTabId}.vikon-tab-pane`).addClass('active');
    });
});
